var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconsShowStickers = function SvgIconsShowStickers(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 500 500",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#76CFA6",
    d: "M250 500c138.571 0 250-111.43 250-250C500 111.429 388.571 0 250 0S0 111.429 0 250c0 138.57 111.429 250 250 250",
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#76CFA6",
    strokeMiterlimit: 10,
    strokeWidth: 12,
    d: "M249 430c-98.996 0-180-81.003-180-180 0-98.998 81.005-180 180-180 98.994 0 180 81.001 180 180 0 98.997-81.005 180-180 180zm72.8-200.8c17.685 0 31.201-13.518 31.201-31.2s-13.519-31.2-31.201-31.2-31.2 13.518-31.2 31.2 13.518 31.2 31.2 31.2zm-145.6 0c17.682 0 31.2-13.518 31.2-31.2s-13.519-31.2-31.2-31.2c-17.683 0-31.201 13.518-31.201 31.2s13.519 31.2 31.201 31.2zM249 364.4c48.883 0 89.436-30.164 106.081-72.801H142.919C159.564 334.236 200.117 364.4 249 364.4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconsShowStickers);
export { ForwardRef as Icon };
export default "img/icons-show-stickers.f790079.svg";